import { createFileRoute } from "@tanstack/react-router";

import AuditAdmin from "@/components/AuditAdmin";

// Generated to match `src/app/admin/audit/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/audit")({
  component: AuditAdmin,
});
